<svg width="34" height="39" viewBox="0 0 34 39" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M33.7576 17.0024C33.7576 33.9355 15.7617 41.5926 15.7617 38.2203C15.2484 38.2203 15.4848 35.41 15.4848 33.9355C6.94767 33.1546 0.257568 25.8715 0.257568 17.0024C0.257568 7.61223 7.7568 0 17.0076 0C26.2583 0 33.7576 7.61223 33.7576 17.0024Z" fill="white"/>
  <circle cx="9.00757" cy="17.5" r="2.5" fill="currentColor"/>
  <circle cx="17.0076" cy="17.5" r="2.5" fill="currentColor"/>
  <circle cx="25.0076" cy="17.5" r="2.5" fill="currentColor"/>
</svg>
